package di

import org.koin.dsl.module
import presentation.viewmodel.ComposableAppViewModel

/**
 * Koin DI module specific to Compose for Web (JS platform)
 * Contains Compose-specific dependencies
 */
val composeModule = module {
    
    // Compose-specific ViewModels
    single { 
        ComposableAppViewModel(
            coreViewModel = get()
        )
    }
}